<template>
  <div class="research-panel-container">
    <ExpansionPanel v-model="isExpanded" :title="title" :img-src="chatbotLogo">
      <slot />
    </ExpansionPanel>
  </div>
</template>
<script>
import { ref } from 'vue';

import chatbotLogo from '~/assets/svg/chatbot-logo.svg';

import ExpansionPanel from '~/components/common/ExpansionPanel.vue';

export default {
  name: 'ThinkingCard',
  components: { ExpansionPanel },
  props: {
    title: {
      type: String,
      default: 'Thinking',
    },
  },
  setup() {
    const isExpanded = ref(false);

    return {
      isExpanded,
      chatbotLogo,
    };
  },
};
</script>

<style scoped lang="scss">
.research-panel-container {
  .divider {
    border: 0;
    height: 1px;
    background-color: #ccc;
    margin-top: $bb-spacing-1;
    margin-bottom: $bb-spacing-1;
  }

  :deep(.v-expansion-panel) {
    background-color: $bb-neutral-6;
    border-radius: 12px;
    padding: $bb-spacing-2 $bb-spacing-4;

    .v-expansion-panel__shadow {
      box-shadow: none;
    }

    .v-expansion-panel-title {
      padding: 0;
      min-height: $bb-spacing-8;

      .v-expansion-panel-title__overlay {
        background-color: $bb-neutral-6;
      }
    }

    .v-expansion-panel-text {
      .v-expansion-panel-text__wrapper {
        padding-left: 0;
        display: flex;
        flex-direction: column;
        gap: $bb-spacing-3;
        max-height: 20vh;
        overflow: scroll;

        & > .document-card-wrapper:last-child {
          .document-details {
            border-bottom: none;
          }
        }

        & > div:last-of-type {
          border: none;

          .divider {
            display: none;
          }
        }
      }
    }
  }

  .toggle-arrow {
    cursor: pointer;
  }
}
</style>
